<template>
  <div class="app-container">
    <BaseDisplay
      :businessBasicDetails="businessBasicDetails"
      :client_server_url="apiBaseURL"
      :token="authToken"
    />
  </div>

  <div
    class="diagnostics-trigger"
    @pointerdown="startLongPress"
    @pointerup="cancelLongPress"
    @pointerleave="cancelLongPress"
  ></div>

  <DiagnosticsPanel
    v-if="showDiagnostics"
    :kiosk-status="kioskStatus"
    @close="showDiagnostics = false"
    @request-fullscreen="kioskRetryFullscreen"
  />

  <footer class="footer">
    <div class="watermark">
      <strong>Powered by </strong>
      <img
        class="watermark-image"
        src="https://storemate.lk/wp-content/uploads/2022/01/Store-Mate-Logo-1-1.webp"
      />
    </div>
  </footer>
</template>

<script>
import BaseDisplay from "./pages/Base_Display.vue";
import APIService from "@/service/APIService";
import { useKioskMode } from "@/kiosk/useKioskMode";
import DiagnosticsPanel from "@/kiosk/DiagnosticsPanel.vue";

export default {
  name: "App",
  components: {
    BaseDisplay,
    DiagnosticsPanel,
  },
  setup() {
    const kiosk = useKioskMode();
    return {
      kioskStatus: kiosk.status,
      kioskStart: kiosk.start,
      kioskStop: kiosk.stop,
      kioskRetryFullscreen: kiosk.retryFullscreen,
    };
  },
  data() {
    return {
      businessBasicDetails: {},
      showDiagnostics: false,
      longPressTimer: null,
    };
  },
  mounted() {
    this.kioskStart();

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("diagnostics") === "1") {
      this.showDiagnostics = true;
    }

    const businessBasicDetails = new APIService(
      this.authToken,
      this.apiBaseURL,
      "business-basic-details"
    );
    businessBasicDetails
      .getData()
      .then((data) => {
        this.businessBasicDetails = data;
      })
      .catch((error) => {
        console.error(error);
      });
  },
  beforeUnmount() {
    this.kioskStop();
  },
  methods: {
    startLongPress() {
      this.longPressTimer = setTimeout(() => {
        this.showDiagnostics = true;
      }, 3000);
    },
    cancelLongPress() {
      clearTimeout(this.longPressTimer);
    },
  },
};
</script>
<style>
.app-container {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 5dvh !important;
  height: 5dvh !important;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}

.watermark {
  position: absolute;
  top: 35%;
  right: 0;
  transform: translate(-30%, -30%);
  font-size: 16px;
  pointer-events: none;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.watermark-image {
  height: 50px;
  width: 50px;
}

.diagnostics-trigger {
  position: fixed;
  top: 0;
  left: 0;
  width: 60px;
  height: 60px;
  z-index: 9998;
}
</style>
